import { Icon, Text } from "@chakra-ui/react";
import { CiUnlock } from "react-icons/ci";
import { useTranslation } from "react-i18next";

const AccessRestrictedPage = () => {
    const { t } = useTranslation("translations");

    return (
        <div className="h-[100vh] flex flex-col justify-center items-center text-center">
            <div className="lock">
                <Icon as={CiUnlock} w={80} h={80} color='teal.500'/>
            </div>
            <div className="message">
                <Text fontSize='30px' fontWeight="bold">{t("ACCESS_TO_THIS_PAGE_IS_RESTRICTED_MESSAGE")}</Text>
                <Text>{t("PLEASE_CONTACT_THE_ADMIN_IF_YOU_THNIK_THIS_IS_WRONG_MESSAGE")}</Text>
                <Text>{t("GO_TO_DASHBOARD")} <a href="/dashboard" className="text-teal-300 underline">{t("HERE")}</a>!</Text>
            </div>
        </div>
    )
}

export default AccessRestrictedPage;